import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Eyebrow } from "@/components/Reveal";

export default function TermsPage() {
  return (
    <main data-testid="terms-page" className="mx-auto max-w-2xl px-5 py-16 sm:py-24">
      <Link to="/" data-testid="back-home-link" className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.3em] text-cream/60 transition-colors hover:text-lime">
        <ArrowLeft className="h-4 w-4" /> BACK
      </Link>
      <Eyebrow>WILD WOMAN MILLIONS™</Eyebrow>
      <h1 className="mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl">Terms of Purchase + Use</h1>
      <p className="mt-2 font-mono text-[10px] tracking-[0.3em] text-cream/40">LAST UPDATED: 2026</p>

      <div className="mt-10 space-y-8 text-sm leading-relaxed text-cream/70">
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">The Product</h2>
          <p>Wild Woman Millions™ is a digital vision experience by Dasha Love, delivered with three digital books and bonus programs. It is sold for a one-time payment of $27 USD. No physical products are shipped.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Access + Delivery</h2>
          <p>Access instructions are delivered digitally after checkout. Please ensure your email address is entered correctly at purchase. If you do not receive access, contact us and we will make it right.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">License</h2>
          <p>Your purchase grants you a personal, non-transferable license to use the course and books. You may not share, resell, redistribute, or publish the materials, in whole or in part.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Educational Purpose + No Guarantees</h2>
          <p>The course provides educational material, guided reflection, and personal-development practices. Individual experiences and results vary. No specific financial or business result is guaranteed. Guided hypnosis, meditation, and breathwork may not be appropriate for everyone — participate according to your own needs and consult a qualified professional where appropriate.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Refunds</h2>
          <p>Because this is an instantly delivered digital product, all sales are generally final. If you experience a genuine issue accessing your purchase, contact us and we will work with you.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Intellectual Property</h2>
          <p>All content, trademarks, and materials remain the property of Dasha Love. “Wild Woman Millions™”, “Clarity Is Currency™” and “Quantum Habits™” are used as trademarks in connection with this product.</p>
        </section>
        <section>
          <h2 className="mb-2 text-base font-extrabold text-cream">Contact</h2>
          <p>Questions about these terms can be sent via the contact link in the footer of this page.</p>
        </section>
      </div>
    </main>
  );
}
